import React from 'react'
import {  Card, Col,  Flex, Row, Typography } from 'antd'
import {  motion } from 'framer-motion';
import { Breadcrumb, UnderlineDesign } from '../../components';
const { Text, Title } = Typography

const PrivacyPolicy = () => {
   
    const data = [
        {
            title:'1. Introduction',
            desc:`At Nextdoor Pros, we prioritize your privacy and are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and safeguard the data you share with us. Whether you're exploring our services or actively engaging with our Web3 fintech solutions, your privacy is of paramount importance. We ensure that all your interactions with our platform are secure, transparent, and aligned with the highest standards of data protection.`,
        },
        {
            title:'2. Data Collection and Usage',
            desc:`We collect various types of information, including personal details, transaction data, and usage patterns, to enhance your experience with our services.`,
        },
        {
            title:'3. Data Sharing and Disclosure',
            desc:`Nextdoor Pros does not sell your personal information to third parties. However, we may share your data with trusted partners and service providers who assist us in operating our platform, conducting business, or serving you. These entities are bound by strict confidentiality agreements and are only permitted to use your information as necessary to perform their services. Additionally, we may disclose your information if required by law or to protect the rights, property, or safety of Nextdoor Pros, our users, or the public.`,
        },
        {
            title:'4. Security Measures',
            desc:`We implement a variety of security measures to ensure the protection of your personal information. These include encryption, secure access protocols, and regular security audits. Our team is dedicated to maintaining the highest security standards, ensuring that your data is safe from unauthorized access, alteration, or disclosure. We continuously review and update our security practices to adapt to new threats and technologies, providing you with a secure environment for all your financial transactions and interactions on our platform.`,
        },
        {
            title:'5. hanges to This Policy',
            desc:`Nextdoor Pros may update this Privacy Policy periodically to reflect changes in our practices, legal requirements, or industry standards. We will notify you of any significant changes through our platform or via email. We encourage you to review this policy regularly to stay informed about how we protect your information and ensure your privacy.`,
        },
    ]

  return (
    <div className=''>
        <Breadcrumb title='Privacy Policy' pageName='Privacy Policy' breadcrumb={[{to:'/',name:'Home'}]}/>
        <div className='container padding-t'>    
            <Row gutter={[24,24]} justify={'center'} className='my-5'>
                <Col lg={{span: 18}} md={{span: 12}} sm={{span: 24}} xs={{span: 24}}>
                    <Flex vertical justify='center' align='center' className='text-center mb-3'>
                        <Flex vertical align='center' className='mb-2' gap={5}>
                            <Title level={2} className='m-0 gradient-text'>
                                Privacy Policy
                            </Title>
                            <UnderlineDesign />
                        </Flex>
                        <Text className='fs-16'>
                            By using Nextdoor Pros, you agree to our terms that prioritize security, transparency, and user empowerment, ensuring a seamless experience on our platform.
                        </Text>
                    </Flex>              
                </Col>
                <Col span={24}>
                    {data.map((content, index)=>(
                        <div key={index} className='mb-3'>
                            <Title level={4} className='text-brand'>
                                {content?.title}
                            </Title>
                            <Text className='fs-16 text-justify'>{content?.desc}</Text>
                        </div>
                    ))}
                </Col>
            </Row>
        </div>
    </div>
  )
}

export {PrivacyPolicy}